import { render, staticRenderFns } from "./signNumberDetail.vue?vue&type=template&id=3ecce4d9&scoped=true&"
import script from "./signNumberDetail.vue?vue&type=script&lang=js&"
export * from "./signNumberDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ecce4d9",
  null
  
)

component.options.__file = "signNumberDetail.vue"
export default component.exports